import React from "react";
import { Button } from "primereact/button";

import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";

import { formatDateFull } from "../../utilities/DateUtil";
// Util
import { srcImagesFile } from "../../utilities/FileUtil";

export const dateColumn = (rowData, isTime, checkColumn, titleShow) => {
    let date = { ...rowData };
    let datevalue = date[`${checkColumn}`];

    let date_arr = datevalue && datevalue !== null ? datevalue.split("/") : [];
    let newDate = date_arr.length === 3 ? date_arr[1] + "/" + date_arr[0] + "/25" + date_arr[2] : "";

    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            {newDate && newDate !== "" ? formatDateFull(newDate, isTime) : "-"}
        </React.Fragment>
    );
};

export const normalColumn = (rowData, checkColumn, titleShow) => {
    let data = { ...rowData };
    let datavalue = data[`${checkColumn}`];
    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            {datavalue && datavalue !== "" && datavalue !== "null"?datavalue === "999"?"":datavalue: "-"}
        </React.Fragment>
    );
};

export const numeralColumn = (rowData, checkColumn, titleShow) => {
    const numeral = require("numeral");
    let data = { ...rowData };
    let datavalue = data[`${checkColumn}`];
    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            {datavalue && datavalue !== "" && datavalue !== "null" ? numeral(datavalue).format("0,0.00") : "-"}
        </React.Fragment>
    );
};

export const perfixLineColumn = (rowData, checkColumn, titleShow) => {
    let data = { ...rowData };
    let datavalue = data[`${checkColumn}`];
    return (
        <React.Fragment>
            <span className="p-column-title" style={{ float: "left" }}>
                {titleShow}
            </span>
            <div style={{ whiteSpace: "pre-wrap", float: "left" }}>{datavalue && datavalue !== "" && datavalue !== "null" ? datavalue.replaceAll(", ", "\n") : "-"}</div>
        </React.Fragment>
    );
};

// Begin ListBox
export const listBoxColumn = (rowData, checkColumn, listboxValue, setListboxValue, mandatory, titleShow, dropName) => {
    let data = { ...rowData };
    let datavalue = (data["checkColumn"] = checkColumn);

    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            <Dropdown value={listboxValue} className={mandatory} onChange={(e) => setListboxValue(e.value, rowData, dropName)} options={datavalue} optionLabel="name" style={{ width: "100%" }} />
        </React.Fragment>
    );
};

export const listBoxColumn_2 = (rowData, checkColumn, listboxValue, setListboxValue, mandatory, titleShow, dropName) => {
    let data = { ...rowData };
    let datavalue = (data["checkColumn"] = checkColumn);
    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            <Dropdown
                id={`${dropName}_${data.index}`}
                value={listboxValue.length > 0 ? listboxValue[data.index][dropName] : ""}
                className={mandatory}
                onChange={(e) => {
                    setListboxValue(e.value, rowData, dropName);
                }}
                options={datavalue}
                optionLabel="name"
                optionValue="code"
                style={{ width: "100%" }}
            />
        </React.Fragment>
    );
};
// End ListBox
// Begin InputText
export const inputTextColumn = (rowData, checkColumn, inputValue, setInputValue, placeholder, titleShow, inputnme, dis, maxText="500") => {
    let data = { ...rowData };
    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            <InputText value={inputValue.length > 0 ? inputValue[data.index][inputnme] : ""} 
            maxLength={maxText} onChange={(e) => setInputValue(e.target.value, rowData, inputnme)} style={{ width: "100%" }} 
            placeholder={placeholder} disabled={dis} />
        </React.Fragment>
    );
};

export const inputTextColumnKeyFilter = (rowData, checkColumn, inputValue, setInputValue, placeholder, titleShow, inputnme, dis, maxText="500") => {
    let data = { ...rowData };
    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            <InputText value={inputValue.length > 0 ? inputValue[data.index][inputnme] : ""} 
            maxLength={maxText} onChange={(e) => setInputValue(e.target.value, rowData, inputnme)} style={{ width: "100%" }} 
            placeholder={placeholder} disabled={dis} keyfilter={/\d|[+]/}/>
        </React.Fragment>
    );
};

export const inputColumn = (rowData, checkColumn, dataList, setInputValue, titleShow, disabled, maxText="500") => {
    let data = { ...rowData };
    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            <InputText value={dataList.length > 0 ? dataList[data.index][checkColumn] : ""} 
            maxLength={maxText} onChange={(e) => setInputValue(e.target.value, data, checkColumn)} style={{ width: "100%" }} 
            placeholder={titleShow} disabled={disabled} />
        </React.Fragment>
    );
};

export const inputNumberColumn = (rowData, checkColumn, inputValue, setInputValue, placeholder, titleShow, inputnme, dis, maxLenht = 99, digits = 2) => {
    let data = { ...rowData };
    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            <InputNumber
                value={inputValue.length > 0 ? inputValue[data.index][inputnme] : ""}
                mode="decimal"
                max={maxLenht}
                onValueChange={(e) => {
                    setInputValue(e.value, rowData, inputnme);
                }}
                style={{ width: "100%" }}
                useGrouping={false}
                minFractionDigits={digits}
                maxFractionDigits={digits}
                placeholder={placeholder}
                disabled={dis}
            />
        </React.Fragment>
    );
};
// End InputText
// Begin Image
export const imageColumn = (rowData, checkColumn, titleShow) => {
    let data = { ...rowData };
    let datavalue = data[`${checkColumn}`];
    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            <img {...srcImagesFile(datavalue)} width="150px" height="80px" />
        </React.Fragment>
    );
};
export const imageColumnClick = (rowData, checkColumn, titleShow, viewImg) => {
    let data = { ...rowData };
    let datavalue = data[`${checkColumn}`];
    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            <img {...srcImagesFile(datavalue)} width="150px" height="80px" onClick={() => viewImg(rowData)} />
        </React.Fragment>
    );
};
// End Image

export const toolTipColumn = (rowData, checkColumn, titleShow) => {
    let data = { ...rowData };
    let datavalue = data[`${checkColumn}`];

    return (
        <React.Fragment>
            <span className="p-column-title">{titleShow}</span>
            <Button icon="pi pi-info-circle" className="p-button p-button-info" tooltip={"ชื่อไฟล์ : " + datavalue} tooltipOptions={{ position: "bottom" }} style={{ width: "21px", height: "21px" }} />
        </React.Fragment>
    );
};

export const actionEditColumn = (rowData, action) => {
    let labelShow = <span className="show-responsive">แก้ไขข้อมูล</span>;
    return (
        <React.Fragment>
            <div style={{ textAlign: "center" }}>
                {/* <Button icon="pi pi-pencil" className="p-button p-button-warning btn-label-responsive btn-md-responsive" onClick={() => action(rowData)} tooltip="คลิกเพื่อ แก้ไข" tooltipOptions={{ position: "top" }} label={labelShow} /> */}
                <Button
                    style={{ backgroundColor: "#1a6a37", border: "1px solid #1a6a37" }}
                    icon="pi pi-pencil"
                    className="p-button p-button-success btn-label-responsive btn-md-responsive"
                    onClick={() => action(rowData)}
                    tooltip="คลิกเพื่อ แก้ไข"
                    tooltipOptions={{ position: "top" }}
                    label={labelShow}
                />
            </div>
        </React.Fragment>
    );
};

export const actionColumnCustomLableWarning = (rowData, action, tip, icon) => {
    let labelShow = <span className="show-responsive">{tip}</span>;
    return (
        <React.Fragment>
            {/* <div className="___inLineFlex p-justify-center"> */}
            <div style={{ textAlign: "center" }}>
                <Button icon={icon} className="p-button p-button-warning btn-label-responsive btn-md-responsive" onClick={() => action(rowData)} tooltip={tip} tooltipOptions={{ position: "top" }} label={labelShow} />
            </div>
        </React.Fragment>
    );
};

export const actionColumnCustomLableHelp = (rowData, action, tip, icon) => {
    let labelShow = <span className="show-responsive">{tip}</span>;
    return (
        <React.Fragment>
            {/* <div className="___inLineFlex p-justify-center"> */}
            <div style={{ textAlign: "center" }}>
                <Button icon={icon} className="p-button p-button-help btn-label-responsive btn-md-responsive" onClick={() => action(rowData)} tooltip={tip} tooltipOptions={{ position: "top" }} label={labelShow} />
            </div>
        </React.Fragment>
    );
};

export const actionColumnCustomLableInfo = (rowData, action, tip, icon) => {
    let labelShow = <span className="show-responsive">{tip}</span>;
    return (
        <React.Fragment>
            {/* <div className="___inLineFlex p-justify-center"> */}
            <div style={{ textAlign: "center" }}>
                <Button icon={icon} className="p-button p-button-info btn-label-responsive btn-md-responsive" onClick={() => action(rowData)} tooltip={tip} tooltipOptions={{ position: "top" }} label={labelShow} />
            </div>
        </React.Fragment>
    );
};

export const actionDelColumn = (rowData, action, dis = false) => {
    let labelShow = <span className="show-responsive">ลบข้อมูล</span>;
    return (
        <React.Fragment>
            <div style={{ textAlign: "center" }}>
                <Button icon="pi pi-trash" className="p-button p-button-danger btn-label-responsive btn-md-responsive" onClick={() => action(rowData)} tooltip="คลิกเพื่อ ลบข้อมูล" tooltipOptions={{ position: "top" }} label={labelShow} disabled={dis} />
            </div>
        </React.Fragment>
    );
};

export const actionDelColumnCusDis = (rowData, action, dis) => {
    let labelShow = <span className="show-responsive">ลบข้อมูล</span>;
    return (
        <React.Fragment>
            <div style={{ textAlign: "center" }}>
                <Button icon="pi pi-trash" className="p-button p-button-danger btn-label-responsive btn-md-responsive" onClick={() => action(rowData)} tooltip="คลิกเพื่อ ลบข้อมูล" tooltipOptions={{ position: "top" }} label={labelShow} disabled={dis} />
            </div>
        </React.Fragment>
    );
};

export const actionChangeColumn = (rowData, action) => {
    let labelShow = <span className="show-responsive">เปลี่ยนสถานะ</span>;
    return (
        <React.Fragment>
            <div className="___inLineFlex p-justify-center">
                <Button icon="pi pi-times-circle" onClick={() => action(rowData)} 
                className="p-button p-button-danger btn-label-responsive btn-md-responsive" 
                tooltip="เปลี่ยนสถานะ" tooltipOptions={{ position: "top" }}  label={labelShow} />
            </div>
        </React.Fragment>
    );
};

export const actionReportColumn = (rowData, action, header) => {
    let labelShow = <span className="show-responsive">{header}</span>;
    let info = "คลิกเพื่อเปิด " + header;
    return (
        <React.Fragment>
            <div style={{ textAlign: "center" }}>
                <Button icon="pi pi-file" className="p-button p-button-secondary btn-label-responsive btn-md-responsive" onClick={() => action(rowData)} tooltip={info} tooltipOptions={{ position: "top" }} label={labelShow} />
            </div>
        </React.Fragment>
    );
};

export const actionPrintColumn = (rowData, action) => {
    let labelShow = <span className="show-responsive">พิมพ์รายงาน</span>;
    return (
        <React.Fragment>
            <div style={{ textAlign: "center" }}>
                <Button icon="pi pi-print" className="p-button btn-label-responsive btn-md-responsive" onClick={() => action(rowData)} tooltip="คลิกเพื่อ พิมพ์รายงาน" tooltipOptions={{ position: "top" }} label={labelShow} />
            </div>
        </React.Fragment>
    );
};

export const statusColumn = (rowData, checkColumn) => {
    let data = { ...rowData };
    let datavalue = data[`${checkColumn}`];
    return (
        <React.Fragment>
            <span className="p-column-title">สถานะ</span>
            <span
                style={{
                    background: datavalue === "A" ? "#c8e6c9" : "#ffcdd2",
                    color: datavalue === "A" ? "#256029" : "#c63737",
                    borderRadius: "2px",
                    padding: ".25em .5rem",
                    textTransform: "uppercase",
                    fontWeight: "700",
                    fontSize: "14px",
                    letterSpacing: ".3px",
                }}
            >
                {datavalue == "A" ? "ใช้งาน" : "ไม่ใช้งาน"}
            </span>
        </React.Fragment>
    );
};

// Upload
export const actionUploadColumn = (rowData, action) => {
    let labelShow = <span className="show-responsive">อัพโหลด</span>;
    return (
        <React.Fragment>
            <div style={{ textAlign: "center" }}>
                <Button icon="pi pi-upload" className="p-button btn-label-responsive btn-md-responsive" onClick={() => action(rowData)} tooltip="คลิกเพื่อ อัพโหลด" tooltipOptions={{ position: "top" }} label={labelShow} />
            </div>
        </React.Fragment>
    );
};
